import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { type O5DeadMessageCustomTableHeaderProps, O5DeadMessagesTable } from '../../../../../../../features/o5/dead-letter/o5-dead-messages-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/dead-message/_dead-message/')({
  head: () => getPageHead('Dead Letters'),
  component: O5DeadMessageList,
});

function TableHeader({ filter, search }: O5DeadMessageCustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      </HorizontalStack>

      {search}
    </VerticalStack>
  );
}

function O5DeadMessageList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5DeadMessagesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
